import { forwardRef, type HTMLAttributes } from 'react';

import styles from './content-wrapper.module.css';

type ContentWrapperTheme = 'terms-of-service' | 'default';

interface ContentWrapperProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'className'> {
  themeType?: 'terms-of-service' | 'default';
}

const contentWrapperClassName = (themeType: ContentWrapperTheme) => {
  if (themeType === 'terms-of-service') {
    return styles['tosContent'];
  }
  return styles['standardContent'];
};

export const ContentWrapper = forwardRef<HTMLDivElement, ContentWrapperProps>(
  ({ themeType, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        className={contentWrapperClassName(themeType ?? 'default')}
        {...rest}
      ></div>
    );
  }
);
